export default __webpack_public_path__ + "static/media/Fantastic_Bigfix_Logo.21641559.png";